import React from 'react';

export interface SearchIconProps {
	color?: string;
	className?: string;
	onClick?: () => void;
	height?: number;
	width?: number;
}

export class SearchIcon extends React.PureComponent<SearchIconProps> {
	get color() {
		return this.props.color ? this.props.color : 'white';
	}

	public override render() {
		const height = this.props.height || 19;
		const width = this.props.width || 18;
		return <svg className={this.props.className} width={width} height={height} viewBox={`0 0 18 19`}
		            onClick={this.props.onClick}>
			<path
				d='M12.52 11.6448H11.73L11.45 11.3748C12.43 10.2348 13.02 8.75478 13.02 7.14478C13.02 3.55478 10.11 0.644775 6.52002 0.644775C2.93002 0.644775 0.0200195 3.55478 0.0200195 7.14478C0.0200195 10.7348 2.93002 13.6448 6.52002 13.6448C8.13002 13.6448 9.61002 13.0548 10.75 12.0748L11.02 12.3548V13.1448L16.02 18.1348L17.51 16.6448L12.52 11.6448ZM6.52002 11.6448C4.03002 11.6448 2.02002 9.63478 2.02002 7.14478C2.02002 4.65478 4.03002 2.64478 6.52002 2.64478C9.01002 2.64478 11.02 4.65478 11.02 7.14478C11.02 9.63478 9.01002 11.6448 6.52002 11.6448Z'
				fill={this.color}/>
		</svg>;
	}
}
